import { MenuProvider } from '../../../../../services/exports/Constants';

export default {
  form: {
    provider: {
      label: 'Menüanbieter',
      options: {
        [null]: 'Menüanbieter auswählen',
        [MenuProvider.Lieferando]: 'Lieferando',
        [MenuProvider.Wolt]: 'Wolt',
        [MenuProvider.Deliveroo]: 'Deliveroo',
        [MenuProvider.UberEats]: 'Uber Eats',
        [MenuProvider.GloriaFood]: 'GloriaFood',
        [MenuProvider.Foodamigos]: 'Andere LebensmittelAmigos Restaurant',
        [MenuProvider.DoorDash]: 'DoorDash',
        [MenuProvider.Tabless]: 'Tabless (POS)',
        [MenuProvider.Thuisbezorgd]: 'Thuisbezorgd',
        [MenuProvider.TakeawayCom]: 'Takeaway.com',
        [MenuProvider.PysznePl]: 'Pyszne.pl',
        [MenuProvider.BistroSk]: 'Bistro.sk',
        [MenuProvider.JustEat]: 'Just Eat',
      },
    },
    provider_id: {
      [MenuProvider.Lieferando]: {
        label: 'Lieferando URL',
        placeholder: 'URL des Restaurants in Lieferando',
      },
      [MenuProvider.Wolt]: {
        label: 'Wolt URL',
        placeholder: 'URL des Restaurants in Wolt',
      },
      [MenuProvider.Deliveroo]: {
        label: 'Deliveroo-Link des Restaurants',
        placeholder: 'https://deliveroo…/menu/city/area/restaurant',
        help: 'Öffnen Sie Ihr Restaurant auf Deliveroo und kopieren Sie den Link aus der Adressleiste.',
        error:
          'Geben Sie den Link zu einer Deliveroo-Speisekarte ein. Er sieht so aus: https://deliveroo.co.uk/menu/city/area/restaurant-name.',
      },
      [MenuProvider.UberEats]: {
        label: 'Uber Eats URL',
        placeholder: 'URL des Restaurants in Uber Eats',
      },
      [MenuProvider.GloriaFood]: {
        label: 'GloriaFood-Link',
        placeholder: 'https://www.foodbooking.com/ordering/restaurant/menu?restaurant_uid=…',
        help: {
          ordering_page: {
            title: 'Wenn Sie die GloriaFood-Bestellseite nutzen:',
            description: 'Geben Sie Ihre foodbooking.com-Bestell-URL ein.',
            example: 'https://www.foodbooking.com/ordering/restaurant/menu?restaurant_uid=…',
          },
          embedded_widget: {
            title: 'Wenn GloriaFood auf Ihrer eigenen Website eingebettet ist:',
            description: 'Geben Sie die URL der Seite Ihrer Website ein, auf der das Bestell-Widget erscheint.',
            example: 'https://ihr-restaurant.de/bestellen',
          },
        },
        error: 'Geben Sie einen gültigen Link ein, der mit https:// beginnt.',
        back_office_error:
          'Das ist ein GloriaFood-Verwaltungslink und nicht die Seite, über die Ihre Kunden bestellen. Öffnen Sie die Bestellseite Ihres Restaurants und fügen Sie diesen Link hier ein.',
        wrong_platform_error:
          'Das sieht nicht nach einem GloriaFood-Link aus. Wenn Sie die von GloriaFood gehostete Bestellseite nutzen, geben Sie Ihre foodbooking.com-Bestell-URL ein. Wenn GloriaFood auf Ihrer eigenen Website eingebettet ist, geben Sie die URL der Seite ein, auf der Ihr Bestell-Widget erscheint.',
      },
      [MenuProvider.Thuisbezorgd]: {
        label: 'Thuisbezorgd URL',
        placeholder: 'URL des Restaurants in Thuisbezorgd',
      },
      [MenuProvider.TakeawayCom]: {
        label: 'Takeaway.com URL',
        placeholder: 'URL des Restaurants in Takeaway.com',
      },
      [MenuProvider.PysznePl]: {
        label: 'Pyszne.pl URL',
        placeholder: 'URL des Restaurants in Pyszne.pl',
      },
      [MenuProvider.BistroSk]: {
        label: 'Bistro.sk URL',
        placeholder: 'URL des Restaurants in Bistro.sk',
      },
      [MenuProvider.JustEat]: {
        label: 'Just Eat URL',
        placeholder: 'URL des Restaurants in Just Eat',
      },
      [MenuProvider.DoorDash]: {
        label: 'DoorDash-Link des Restaurants',
        placeholder: 'https://www.doordash.com/store/…',
        help: 'Öffnen Sie Ihr Restaurant auf doordash.com und kopieren Sie den Link aus der Adressleiste.',
        error:
          'Geben Sie den Link zu einer DoorDash-Restaurantseite ein. Er beginnt mit https://www.doordash.com/store/.',
        store_number_error:
          'Dieser Link enthält nur die Filialnummer. Öffnen Sie das Restaurant auf doordash.com und kopieren Sie den Link mit seinem Namen, z. B. https://www.doordash.com/store/restaurant-name-123456/.',
      },
      [MenuProvider.Foodamigos]: {
        label: 'Restaurant zum Kopieren der Speisekarte von',
        placeholder: 'Wählen Sie das Restaurant, aus dem Sie das Menü kopieren möchten',
      },
    },
  },
};
